module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1r4n8r-c36ccab0103c8d740a18ecb96d4e60e9.svg";